import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errorMessage } from "@/lib/api";
import { generatePassword } from "@/lib/password";
import { CredentialsBox } from "@/components/platform/NewCompanyDialog";

export const ResetPasswordDialog = ({ company, onClose }) => {
  const [password, setPassword] = useState(generatePassword());
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(null);

  const close = () => { setPassword(generatePassword()); setDone(null); onClose(); };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post(`/platform/companies/${company.id}/reset-password`, { password });
      setDone({ email: data.email, password });
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!company} onOpenChange={(o) => !o && close()}>
      <DialogContent className="border-slate-700 bg-slate-900 sm:max-w-md" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold">Nova senha</DialogTitle>
          <DialogDescription>{company?.company_name} · {company?.owner_email}</DialogDescription>
        </DialogHeader>
        {done ? <CredentialsBox email={done.email} password={done.password} phone={company?.phone} /> : (
          <form onSubmit={submit} className="space-y-3">
            <div className="flex gap-2">
              <Input required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="bg-slate-950 font-mono" data-testid="reset-password-input" />
              <Button type="button" variant="outline" className="border-slate-700 bg-transparent" onClick={() => setPassword(generatePassword())} title="Gerar senha"><KeyRound className="h-4 w-4" /></Button>
            </div>
            <Button type="submit" disabled={saving} className="w-full rounded-full font-semibold" data-testid="reset-password-submit">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar nova senha
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
